export default {
    path: '/dqlist',
    name: 'dqlist',
    component: () => import('@/views/DqList.vue'),
    children: [
        {
            path: '/dqlist/ChineseFood',
            name: 'ChineseFood',
            component: () => import('@/views/dqList/ChineseFood.vue'),
            children:[
                {
                    path: ':type',
                    component: () => import('@/components/ClassList/List.vue'),
                }
            ]
        },
        {
            path: '/dqlist/DessertFood',
            name: 'DessertFood',
            component: () => import('@/views/dqList/DessertFood.vue'),
            children:[
                {
                    path: ':type',
                    component: () => import('@/components/ClassList/List.vue'),
                }
            ]
        },
        {
            path: '/dqlist/WesternStyleFood',
            name: 'WesternStyleFood',
            component: () => import('@/views/dqList/WesternStyleFood.vue'),
            children:[
                {
                    path: ':type',
                    component: () => import('@/components/ClassList/List.vue'),
                }
            ]
        },
        {
            path: '/dqlist/DrinkFood',
            name: 'DrinkFood',
            component: () => import('@/views/dqList/DrinkFood.vue'),
            children:[
                {
                    path: ':type',
                    component: () => import('@/components/ClassList/List.vue'),
                }
            ]
        },
        {
            path: '/dqlist',
            redirect: '/dqlist/ChineseFood'
        }
    ]
}